import adminApiClient from './adminApiClient';

export const adminChatbotsService = {
  getByCompany:   (companyId)             => adminApiClient.get(`/api/chatbots?companyId=${companyId}`),
  getById:        (id, companyId)         => adminApiClient.get(`/api/chatbots/${id}?companyId=${companyId}`),
  update:         (id, companyId, data)   => adminApiClient.put(`/api/chatbots/${id}?companyId=${companyId}`, data),
  getAnalytics:   (companyId, period)     => adminApiClient.get(`/api/chatbots/analytics?period=${period}&companyId=${companyId}`),
  getConversations: (chatbotId, companyId, page = 0, size = 5) =>
    adminApiClient.get(`/api/chatbots/conversations?chatbotId=${chatbotId}&companyId=${companyId}&page=${page}&size=${size}`),
};

export default adminChatbotsService;
